import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ConsentComplete } from '../pathways-ui/models/consent-completed.model';
import { StudentConsentModel } from '../pathways-ui/models/student-consent.model';
import { UpdateStatusModel } from '../pathways-ui/models/updateStatus.model';
import { UpdateStudentStatusModel } from '../pathways-ui/models/update-student-status.model';

@Injectable({
  providedIn: 'root'
})
export class SpRegisterService {

  constructor(private http: HttpClient) {}

  registerController = '/api/Register';

  updateStudentStatus(statusUpdateObject: UpdateStudentStatusModel): Observable<Object> {
    return this.http
      .post<Object>(
        `${this.registerController}/UpdateStudentStatus`,
        statusUpdateObject
      )
      .pipe(map((data) => data));
  }

  updateSingleRegistrationStatus(status: number): Observable<Object> {
    return this.http
      .post<Object>(
        this.registerController + '/UpdateSingleRegistrationStatus',
        {
          status,
        }
      )
      .pipe(
        map((data) => {
          return data;
        })
      );
  }

  updateStudentConsentLink(
    consentData: ConsentComplete
  ): Observable<StudentConsentModel> {
    return this.http
      .post<StudentConsentModel>(
        `${this.registerController}/UpdateStudentConsentLink`,
        consentData
      )
      .pipe(map((data) => data));
  }


}
